import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./promoc.scss";

const Promoc = ({ imagehs, titlepromo, details, whatsappLink, quote }) => {
  const renderDetail = (detail) => {
    const parts = detail.split(" ");
    const iconClass = parts.shift(); // Remove and get the first part as icon class

    // Determine FontAwesome icon based on class name
    let iconComponent = null;
    switch (iconClass) {
      case "fa-check":
        iconComponent = <FontAwesomeIcon icon={faCheckDouble} />;
        break;
      default:
        break;
    }

    // Render the detail item
    return (
      <div className="penawaranpoin">
        {iconComponent && <span>{iconComponent}</span>}
        <span style={{ color: "#000000" }}>&nbsp;&nbsp;{parts.join(" ")}</span>
      </div>
    );
  };

  return (
    <div className="container-promo">
      <div className="promo">
        <div className="containercontent">
          <div id="promo" className="judul-promo">
            {titlepromo}
          </div>
          <div className="pointpenawaran">
            {Object.values(details).map((detail, index) =>
              renderDetail(detail),
            )}
          </div>
          <div className="disclaimer">
            *Syarat dan Ketentuan Berlaku, promo dapat berubah mengikuti program
            promosi marketing
          </div>
          <div className="button-wa-promo">
            <button
              onClick={() => window.open(whatsappLink, "_blank")}
              className="whatsapp"
            >
              <FontAwesomeIcon icon={faWhatsapp} /> Get More Promo
            </button>
          </div>
        </div>
        <div className="containergambar">
          <img className="penawarangambar" src={imagehs} alt="hardsell" />
        </div>
      </div>
      <div className="contquote">
        <div className="quote">{quote}</div>
      </div>
    </div>
  );
};

export default Promoc;
